const big = '2rem';
const small = '1rem';
export default {
  big,
  small,
};
